export const usesStagingApi = () => {
  const host = window.location.hostname;
  return host.includes(".staging.") || host.includes("localhost");
};
